import { Controller } from 'stimulus'

export default class extends Controller {
  static get targets() {
    return ['initialOptions', 'additionalOptions', 'menuButton', 'hiddenSelect']
  }

  connect() {
    const app = this
    $(this.initialOptionsTarget).find('[role="radio"]').focus(function() {
      app.pickHorizontalRadioButtonGroupOption($(this))
      const menuToggleButton = $(this).parent().next('.molecule-menu').children('button')
      app.updateHorizontalRadioButtonGroupToggleLabel('More', 'options available. Click to see them.', menuToggleButton)
    })
    $(this.additionalOptionsTarget).find('[role="radio"]')
      .click(function() {
        app.onUpdateTrigger($(this))
      })
      .keydown(function(event) {
        // Enter or Space
        event.stopPropagation()
        if (event.which === 13 || event.which === 32) {
          app.onUpdateTrigger($(this))
        }
      })
    $(this.additionalOptionsTarget).find('[role="radio"][aria-checked="true"]').click()
  }

  pickHorizontalRadioButtonGroupOption(radio) {
    $(this.initialOptionsTarget).find('[role="radio"]').attr('aria-checked', 'false')
    $(this.additionalOptionsTarget).find('[role="radio"]').attr('aria-checked', 'false')
    radio.attr('aria-checked', 'true')
    const value = radio.data('value')
    $(this.hiddenSelectTarget).val(value)
    const menuToggleButton = radio.closest('.molecule-menu').find("button[aria-haspopup='true']")
    menuToggleButton.focus()
  }

  updateHorizontalRadioButtonGroupToggleLabel(visibleLabel, screenReaderLabel, toggleButtonInstance) {
    toggleButtonInstance.children('.a11y-visually-visible').text(visibleLabel)
    toggleButtonInstance.children('.a11y-visually-hidden').text(screenReaderLabel)
    toggleButtonInstance.attr('aria-pressed', visibleLabel !== 'More')
  }

  onUpdateTrigger(target) {
    this.pickHorizontalRadioButtonGroupOption(target)
    const label = target.text().trim()
    const menuButton = target.parent().prev('button')
    this.updateHorizontalRadioButtonGroupToggleLabel(label, ' selected. Click to see more Action type options.', menuButton)
    $(this.menuButtonTarget).trigger('click')
  }
}
